import moment from "moment";

export type IcdCodeTypes = {
  icdId: number;
  icdDescription: string;
  icdCode: string;
};

export type DiagnosisListType = {
  diagnosisId: number | null;
  diagOrder: number | null;
  diagnosisType: "Principal" | "Secondary";
  diagnosisDetails: string;
  icdCode: IcdCodeTypes | null;
  doneBy: string;
  status: boolean;
  isActive:boolean
  encounterId: number | null;
  createdDate:string | Date;
};

export type DiagnosisContextType = {
  list: DiagnosisListType[];
  setList: (
    param:
      | DiagnosisListType[]
      | ((item: DiagnosisListType[]) => DiagnosisListType[])
  ) => void;
  edit: DiagnosisListType | null;
  setEdit: (param: DiagnosisListType | null) => void;
};

export type DiagnosisPayload = {
  fromVerification: boolean;
  diagnosisId: number | null;
  icdId: number;
  encounterId: number;
  diagnosisType: "Principal" | "Secondary";
  isActive: boolean;
  yearOfOnset: number;
  diagOrder: number;
  narrate: string;
  isModified: number;
  createdDate: string | Date;
  status: number;
  revertFlag: boolean;
  dateOfOnset: string | Date;
  lifeCycleStatus: number;
  snomedId: number;
  notes: string;
  actionCode: string;
  actionDate: string;
  hl7MsgStatus: number;
  approvalId: number;
};

export const defaultValues = {
  diagnosisId: null,
  diagOrder: null,
  diagnosisType: "Principal",
  diagnosisDetails: "",
  icdCode: null,
  doneBy: "",
  status: true,
  encounterId: null,
} as DiagnosisListType;

export const preparePayload = (data: DiagnosisListType): DiagnosisPayload => {
  return {
    fromVerification: false,
    diagnosisId: data.diagnosisId || null,
    icdId: (data.icdCode as IcdCodeTypes).icdId,
    encounterId: data.encounterId as number,
    diagnosisType: data.diagnosisType,
    isActive: data.isActive,
    yearOfOnset: moment().year(),
    diagOrder: data.diagOrder as number,
    narrate: (data.icdCode as IcdCodeTypes).icdDescription,
    isModified: 0,
    createdDate: data.createdDate,
    status: 1,
    revertFlag: false,
    dateOfOnset: moment().format("YYYY-MM-DD"),
    lifeCycleStatus: 3,
    snomedId: (data.icdCode as IcdCodeTypes).icdId,
    notes: data.diagnosisDetails || "",
    actionCode: "UPDATED",
    actionDate: moment().toISOString(),
    hl7MsgStatus: 0,
    approvalId: 0,
  };
};
